document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-before-after]').forEach((slider) => {
    const range = slider.querySelector('.woolora-before-after__range');
    const afterLayer = slider.querySelector('[data-after-layer]');

    range?.addEventListener('input', () => {
      afterLayer.style.width = `${range.value}%`;
    });
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const buttons = gallery.querySelectorAll('[data-filter]');
    const cards = gallery.querySelectorAll('[data-category]');

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');

        const filter = button.dataset.filter;
        cards.forEach((card) => {
          card.hidden = filter !== 'all' && card.dataset.category !== filter;
        });
      });
    });

    buttons[0]?.classList.add('is-active');
  });
});
